import React, { Component } from 'react';
import { formatAccessTime, getPlanDescription } from '../helpers/monthlyRegistrationHelpers';

class PlanCard extends Component {
  handleSelect = () => {
    const { plan, onSelect } = this.props;
    if (onSelect) {
      onSelect(plan);
    }
  };

  render() {
    const { plan, isSelected, parkingId, is207CollegeSt, is700BiscayneLot } = this.props;
    const detail = plan.pricing_data || {};
    const cardClass = ['plan-card', isSelected ? 'plan-card--selected' : '']
      .join(' ')
      .trim();

    // Use displayName if available (formatted), otherwise fallback to pricing_type
    const displayName = plan.displayName || plan.pricing_type || '';
    
    // Format access time based on allowed_time_config
    const accessTimeData = formatAccessTime(detail.allowed_time_config);
    
    // Get description from pricing_data safely
    const description = getPlanDescription(detail);

    // Lot-specific logic
    const is207CollegeStVentureXPlan = is207CollegeSt && plan.pricing_type === "VentureX";

    return (
      <button type="button" className={cardClass} onClick={this.handleSelect}>
        <div className="plan-card__header">
          <h3 className="plan-card__title">{displayName}</h3>
          {isSelected && <span className="plan-card__selected-indicator">✓</span>}
        </div>
        <div className="plan-card__price-row">
          <span className="plan-card__price">
            $
            {detail.rental_fee
              ? (detail.rental_fee / 100).toLocaleString(undefined, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                })
              : '0'}
          </span>
          <span className="plan-card__price-period">{plan?.subscriptionType === 'individual' ? "/month" : "/month per user"}</span>
          {parkingId == 6029 && detail.rental_fee == 18458 && (
            <span className="plan-card__price-tax">($150 + Taxes)</span>
          )}
        </div>
        <div className="plan-card__description">
          {is207CollegeStVentureXPlan ? (
            <>
              <span className="plan-card__description-text">
                Only Weekdays (7AM to 5PM) Excluding Holidays & Events
              </span>
            </>
          ) : is700BiscayneLot ? (
            <>
              <span className="plan-card__description-text">
                Weekdays (9AM to 5PM) No Access: Events & Weekends
              </span>
            </>
          ) : (
            <>
              {accessTimeData.type === 'multiline' ? (
                <div className="plan-card__description-multiline">
                  {accessTimeData.content.map((line, index) => {
                    // Split line into start time, dash, end time, and day parts (format: "12am – 11:59pm Monday")
                    const dayMatch = line.match(/\s(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)$/);
                    if (dayMatch) {
                      const timePart = line.substring(0, dayMatch.index).trim();
                      const dayPart = dayMatch[1];
                      
                      // Split time part into start, dash, and end (format: "12am – 11:59pm")
                      const timeMatch = timePart.match(/^(.+?)\s*[–-]\s*(.+)$/);
                      if (timeMatch) {
                        const startTime = timeMatch[1].trim();
                        const dash = timePart.match(/[–-]/)?.[0] || '–';
                        const endTime = timeMatch[2].trim();
                        
                        return (
                          <div key={index} className="plan-card__description-line">
                            <span className="plan-card__description-start">{startTime}</span>
                            <span className="plan-card__description-dash">{dash}</span>
                            <span className="plan-card__description-end">{endTime}</span>
                            <span className="plan-card__description-day">{dayPart}</span>
                          </div>
                        );
                      }
                    }
                    // Fallback if no day found or parsing failed
                    return (
                      <div key={index} className="plan-card__description-line">
                        {line}
                      </div>
                    );
                  })}
                </div>
              ) : (
                <span className="plan-card__description-text">{accessTimeData.content}</span>
              )}
            </>
          )}
        </div>
        <p className="plan-card__note">
          {description}
        </p>
      </button>
    );
  }
}

export default class PlanGrid extends Component {
  renderEmptyState() {
    return (
      <div className="plan-grid__empty">
        <p>No plans available right now</p>
      </div>
    );
  }

  render() {
    const { plans, selectedPlanId, onSelectPlan, parkingId, is207CollegeSt, is700BiscayneLot } = this.props;
    if (!plans || !plans.length) {
      return this.renderEmptyState();
    }

    return (
      <div className="plan-grid-scroll">
        <div className="plan-grid">
          {plans.map((plan) => (
            <PlanCard
              key={plan.id}
              plan={plan}
              isSelected={selectedPlanId === plan.id}
              onSelect={onSelectPlan}
              parkingId={parkingId}
              is207CollegeSt={is207CollegeSt}
              is700BiscayneLot={is700BiscayneLot}
            />
          ))}
        </div>
      </div>
    );
  }
}

